import { render } from "./Recommended.vue?vue&type=template&id=1a580514&scoped=true&ts=true"
import script from "./Recommended.vue?vue&type=script&lang=ts"
export * from "./Recommended.vue?vue&type=script&lang=ts"

import "./Recommended.vue?vue&type=style&index=0&id=1a580514&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a580514"]])

export default __exports__